import React from "react";
import { GRADE_STYLE, ACCESS_STYLE } from "@/lib/content";
import { ShieldCheck } from "lucide-react";

export function GradeBadge({ grade, className = "" }) {
  if (!grade) return null;
  return (
    <span
      data-testid={`grade-badge-${grade}`}
      className={`inline-flex items-center gap-1 px-3 py-1 text-xs rounded-full border tracking-wider font-mono-i ${GRADE_STYLE[grade] || GRADE_STYLE.Bronze} ${className}`}
    >
      {grade}
    </span>
  );
}

export function AccessBadge({ level, className = "" }) {
  if (!level) return null;
  return (
    <span
      data-testid={`access-badge-${level}`}
      className={`inline-flex items-center px-3 py-1 text-xs rounded-full border tracking-wider ${ACCESS_STYLE[level] || ACCESS_STYLE.Member} ${className}`}
    >
      {level}
    </span>
  );
}

export function VerifiedTag({ verified }) {
  if (!verified) return null;
  return (
    <span className="inline-flex items-center gap-1 text-emerald-400 text-xs font-medium" data-testid="verified-tag">
      <ShieldCheck className="w-3.5 h-3.5" /> Verified
    </span>
  );
}

export function ConfidencePill({ value }) {
  const tone = value >= 85 ? "text-emerald-400 border-emerald-500/40" : value >= 60 ? "text-[#F1551D] border-amber-500/40" : "text-rose-400 border-rose-500/40";
  return (
    <span className={`font-mono-i text-[11px] px-2 py-0.5 rounded border ${tone}`}>
      CONF {value}%
    </span>
  );
}
